import React from 'react';
import { InView } from 'react-intersection-observer';
import { TopProductIds } from './types';
import ProductHeader from './product-header';
import { ProductPageQuery } from '../../../../types';

const ProductPageHeader: React.FC<IProductPageHeaderProps> = props => {
  const {
    product,
    setHeaderVisible,
    isHeaderVisible,
    currentCampaign,
    shouldRenderAllTabs,
  } = props;
  if (!product) {
    return null;
  }

  const onHeaderVisibilityChange = (isVisible: boolean) => {
    if (isHeaderVisible !== isVisible) {
      setHeaderVisible(isVisible);
    }
  };

  return (
    <InView onChange={onHeaderVisibilityChange}>
      <ProductHeader
        title={product.name}
        product={product}
        currentCampaign={currentCampaign}
        categoryTopProducts={getCategoryTopProducts(product)}
        shouldRenderAllTabs={shouldRenderAllTabs}
      />
    </InView>
  );
};

const getCategoryTopProducts = (
  product: ProductPageQuery['product']
): TopProductIds | null => {
  if (!product?.category?.products?.nodes.length) return null;

  // Returns array with current product id + top 10 product ids in same category.
  const topTenIds = product.category.products.nodes
    .filter(node => node?.id && product?.id && node.id !== product.id)
    .map(node => {
      return { id: node!.id };
    });

  return [{ id: product.id }, ...topTenIds];
};

interface IProductPageHeaderProps {
  product: ProductPageQuery['product'];
  isHeaderVisible: boolean;
  setHeaderVisible: React.Dispatch<React.SetStateAction<boolean>>;
  currentCampaign: any;
  shouldRenderAllTabs: boolean;
}

export default ProductPageHeader;
